import React from 'react';
import ReactDOM from 'react-dom/client';
import "./lib/polyfills";
import App from './App.tsx';
import './index.css';
import './lib/error-handling/sentry/bootstrap.ts';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
